import useDocumentMeta from "@/hooks/useDocumentMeta";
import { movies } from "@/data/videos";
import { movieGenres } from "@/mocks/filters";
import CategoryBrowser from "@/pages/category/components/CategoryBrowser";

export default function MovieCategory() {
  useDocumentMeta({
    title: "电影频道 - 51无敌电影网",
    description:
      "51无敌电影网电影频道，汇集最新院线大片与经典佳作，支持按类型、地区、年份筛选和热度、评分排序，轻松发现好看的电影。",
    keywords: "最新电影,在线电影,电影大全,高分电影,电影频道,51无敌电影网",
  });

  return (
    <CategoryBrowser
      title="电影频道 - 最新、最全电影列表"
      subtitle="汇聚最新院线电影与经典佳作，支持类型、地区、年份筛选，快速找到你想看的那一部。"
      categoryLabel="电影"
      categoryLink="/category/movie"
      items={movies}
      genreOptions={movieGenres}
    />
  );
}